const Topics = [
  "Array",
  "Binary Search",
  "Bit Manipulation",
  "Breadth First Search",
  "Depth First Search",
  "Dynamic Programming",
  "Graph",
  "Greedy",
  "Linked List",
  "Math",
  "Ordered Set",
  "Queue",
  "Segment Tree",
  "Sliding Window",
  "Stack",
  "Topological Sort",
  "Tree",
  "Trie",
  "Two Pointers",
  "Miscellaneous",
];

export default Topics;
